import React, { useState } from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Persona } from '@rd-web-markets/shared/dist/util/Persona';
import { Button, MarketDeleteButton } from '../../util/buttons';
import { useModalConfirm } from '../../hooks/useModalConfirm';
export default function ContactCard(_ref) {
  let {
    user,
    roles,
    label,
    userAccess,
    showAymingLogo,
    editUserAccess,
    handleDelete,
    handleExclude,
    additionalBodyContent,
    canEdit = true
  } = _ref;
  const [showDetails, setShowDetails] = useState(false);
  const {
    t
  } = useTranslation();
  const confirmDeleteUserAccess = useModalConfirm({
    type: 'delete',
    confirmationButtonText: user.name,
    onConfirm: () => handleDelete(userAccess.id)
  });
  return /*#__PURE__*/React.createElement(Card, {
    className: "me-2"
  }, /*#__PURE__*/React.createElement(Card.Header, {
    className: `${showAymingLogo ? 'custom-card-header-logo' : 'custom-card-header'}`,
    onClick: () => setShowDetails(!showDetails)
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-between"
  }, /*#__PURE__*/React.createElement(Persona, {
    whiteText: true,
    user: user,
    description: roles.map(role => {
      return t(role);
    }).join(', ')
  }), userAccess && /*#__PURE__*/React.createElement("div", null, (user.account_type !== 'accountant' || user.account_type !== 'customer') && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    isImmutableUnderReview: true,
    onClick: () => editUserAccess(userAccess),
    variant: "light",
    className: "p-1 d-inline-flex me-1",
    disabled: !canEdit
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons md-18 text-info mx-auto"
  }, "edit"))), handleDelete && /*#__PURE__*/React.createElement(MarketDeleteButton, {
    isImmutableUnderReview: true,
    className: "p-1 d-inline-flex",
    onClick: confirmDeleteUserAccess,
    disabled: !canEdit
  })), handleExclude && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
    variant: "light",
    className: "p-1 d-inline-flex ",
    onClick: () => handleExclude(),
    disabled: !canEdit
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons md-18 text-warning mx-auto"
  }, "delete")))), label && /*#__PURE__*/React.createElement("div", {
    style: {
      color: 'white',
      padding: '5px',
      backgroundColor: '#0078B9',
      fontWeight: 'bold',
      marginTop: '5px'
    }
  }, t(label))), showDetails && /*#__PURE__*/React.createElement(Card.Body, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("span", {
    className: "material-icons text-primary me-2"
  }, "call"), " ", user.phone_number)), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("span", {
    className: "material-icons text-primary me-2"
  }, "mail"), " ", user.email)), additionalBodyContent && additionalBodyContent));
}